import { FC } from "react"
import { useFeatureFlag } from "Hooks/useFeatureFlag"
import Button from "Components/UI/Button"
import { loadImage } from "Utils/MultidomailUtils"
import { Container, TopContainer, BottomContainer } from "./styles"

interface IFollowInfoCardProps {
  onClose: () => void
}

const FollowInfoCard: FC<IFollowInfoCardProps> = ({ onClose }) => {
  const followFolderInfoCardUrlFlag = useFeatureFlag('follow-folder-info-card-url')
  const followFolderInfoCardUrl = (followFolderInfoCardUrlFlag.enabled && typeof followFolderInfoCardUrlFlag.value === 'string')
    ? followFolderInfoCardUrlFlag.value
    : 'https://maleta.doengenheiro.com.br/'

  const redirect = () => {
    window.open(followFolderInfoCardUrl)
  }

  return (
    <Container>
      <TopContainer>
        <img src={loadImage('info-follow-card-img.svg')} alt="FollowInfoCard" />
      </TopContainer>
      <BottomContainer>
        <div><span className="tagNew">NOVIDADE</span></div>
        <div className="titleContainer">
          <span className="title">
            Siga pastas para receber notificações de atualizações em tempo real.
          </span>
          <span className="description">
            Ao seguir pastas, você será notificado imediatamente sobre todas as atualizações importantes. Você pode configurar as notificações na página de preferências de notificações.
          </span>
        </div>
        <div className="buttonContainer">
          <Button type="text" onClick={redirect}>Saiba mais</Button>
          <Button type="text" onClick={onClose}>Fechar</Button>
        </div>
      </BottomContainer>
    </Container>
  )
}

export default FollowInfoCard
